import { Controller, type Control } from 'react-hook-form';
import ReCAPTCHA from 'react-google-recaptcha';

import { getEnvVariable } from '@ciam/env';
import { useCaptchaStore } from '@features/login';

import type { FieldValues, Path } from 'react-hook-form';

type CaptchaControllerProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
};

export const CaptchaController = <T extends FieldValues>({ control, name }: CaptchaControllerProps<T>) => {
  const { isShowCaptcha } = useCaptchaStore();

  if (!isShowCaptcha) return null;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange } }) => (
        <ReCAPTCHA
          grecaptcha={window.grecaptcha}
          sitekey={getEnvVariable('VITE_CAPTCHA_SITE_KEY')}
          onChange={onChange}
          onExpired={() => onChange('')}
          onErrored={() => onChange('')}
          style={{ margin: '0 auto 2.4rem auto' }}
        />
      )}
    />
  );
};
